/**
 * GasRecentlyViewed — tracks visited product handles in localStorage and
 * renders them client-side via the /products/{handle}.js JSON endpoint
 * (that endpoint doesn't expose metafields, so unlike the server-rendered
 * snippets/product-card.liquid these cards never show a rating).
 */
(function () {
  const STORAGE_KEY = 'gasseth:recently-viewed';
  const MAX_STORED = 12;

  function readHandles() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  function track(handle) {
    if (!handle) return;
    const handles = readHandles().filter((h) => h !== handle);
    handles.unshift(handle);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
  }

  function badgeFor(product) {
    const tagBadge = (product.tags || []).find((tag) => tag.startsWith('badge:'));
    if (tagBadge) return tagBadge.slice('badge:'.length);
    if (product.compare_at_price && product.compare_at_price > product.price) return null;
    return null;
  }

  function cardHtml(product) {
    const image = product.featured_image ? product.featured_image.replace(/(\.[^.?]+)(\?|$)/, '_400x$1$2') : '';
    const price = window.GasCart ? GasCart.formatMoney(product.price) : `$${(product.price / 100).toFixed(2)}`;
    const compareAt =
      product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="product-price__old">${window.GasCart ? GasCart.formatMoney(product.compare_at_price) : ''}</span>`
        : '';
    const badge = badgeFor(product);

    return `
    <a class="product-card" href="${product.url}" aria-label="Ver producto: ${product.title}">
      <div class="product-card__media">
        ${badge ? `<span class="product-card__badge">${badge}</span>` : ''}
        <img class="product-card__image" src="${image}" alt="${product.title}" loading="lazy" width="280" height="280" />
      </div>
      <p class="product-card__name">${product.title}</p>
      <div class="product-card__price">
        <span class="product-price__current">${price}</span>
        ${compareAt}
      </div>
    </a>`;
  }

  async function render(container, { limit = 8, excludeHandle, emptyMessage = '' } = {}) {
    const handles = readHandles()
      .filter((handle) => handle !== excludeHandle)
      .slice(0, limit);

    if (handles.length === 0) {
      container.closest('[data-recently-viewed-section]')?.setAttribute('hidden', '');
      if (emptyMessage) container.innerHTML = `<p class="recently-viewed__empty">${emptyMessage}</p>`;
      return;
    }

    const products = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null),
      ),
    );

    const valid = products.filter(Boolean);
    if (valid.length === 0) {
      container.closest('[data-recently-viewed-section]')?.setAttribute('hidden', '');
      return;
    }

    container.innerHTML = valid.map(cardHtml).join('');
  }

  window.GasRecentlyViewed = { track, render };
})();
